import { get } from '../../../common/data/common-data-service';
import { IDiagramResponse } from '../diagram-interfaces';

export const getDiagramData = async (todo_id: number) : Promise<IDiagramResponse> => {
    return await get(`/api/diagram/get?todo_id=${ todo_id }`);
};